/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as Styles from '../../../../../SharedModules/StyleConstant/StyleConstant';
import MaxLengthNumericEditor from '../../../../../SharedModules/CustomAgGridEditor/inputComponent';
import CustomGridCellRendererComponent from '../../../../../SharedModules/AgGridUtilities/CustomGridCellRenderercomponent';

function amountComparator(amount1, amount2) {
  var newAmt1, newAmt2;
  if (amount1 === null && amount2 === null) {
    return 0;
  }
  if (amount1 === null) {
    return -1;
  }
  if (amount2 === null) {
    return 1;
  }
  if (amount1 === 0) {
    return -1;
  }
  if (amount2 === 0) {
    return 1;
  }
  if (amount1 !== 0) {
    newAmt1 = parseFloat(amount1.replace('$', '').trim());
  }
  if (amount2 !== 0) {
    newAmt2 = parseFloat(amount2.replace('$', '').trim());
  }

  return newAmt1 - newAmt2;
}

function amountSecondComparator(amount1, amount2) {
  let amt1 = null;
  let amt2 = null;
  if (amount1 && amount1?.toString()?.includes('$')) {
    amt1 = parseFloat(amount1?.toString().split('$')[1]);
  } else {
    amt1 = amount1;
  }
  if (amount2 && amount2?.toString()?.includes('$')) {
    amt2 = parseFloat(amount2?.toString().split('$')[1]);
  } else {
    amt2 = amount1;
  }
  if (amt1 === null && amt2 === null) {
    return 0;
  }
  if (amt1 === null) {
    return -1;
  }
  if (amt2 === null) {
    return 1;
  }

  return amt1 - amt2;
}

// eslint-disable-next-line import/prefer-default-export
export const TableHeaderForManufacturer = [
  {
    headerName: 'Manufacturer ID',
    field: 'mfgId',
    sort: 'asc',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    sortable: true,
    resizable: false,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const TableHeaderForDetails = [
  {
    headerName: 'NDC',
    field: 'ndc',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_200,
    cellRenderer: 'HyperLinkNameRender',
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Drug Name',
    field: 'drugName',
    editable: false,
    sortable: true,
    resizable: true,
    suppressMenu: false,
    columnSpan: 3,
    minWidth: Styles.Width_250,
    cellRenderer: 'FullNameRender',
    cellClass: 'frr-ellipsis-text',

    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
  },
  {
    headerName: 'URA',
    field: 'unitRebateAmt',
    editable: false,
    sortable: true,
    resizable: true,
    suppressMenu: false,
    minWidth: Styles.Width_150,
    comparator: amountComparator,

    cellEditor: MaxLengthNumericEditor,
    excelAlignment: 'right',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    sortingOrder: ['desc', 'asc'],
    dataAlignRight: true,
    exportZeroesSix: true,
    cellRenderer: 'UnitRebateAmtCellRender',

    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Adjusted URA',
    field: 'adjustedUnitRebateAmt',
    comparator: amountComparator,
    editable: false,
    sortable: true,
    resizable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellRenderer: 'UnitRebateAmtCellRender',
    cellEditor: MaxLengthNumericEditor,
    excelAlignment: 'right',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    dataAlignRight: true,
    sortingOrder: ['desc', 'asc'],
    exportZeroesSix: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Units Invoiced',
    field: 'tot_reimbursed_Units',
    editable: false,
    sortable: true,
    isTextColorRed: true,
    resizable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    comparator: amountComparator,
    cellRenderer: 'TotalUnitsCellRender',
    cellEditor: MaxLengthNumericEditor,
    excelAlignment: 'right',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    dataAlignRight: true,
    exportZeroesThree: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Adjusted Units',
    field: 'adjustedUnits',
    comparator: amountSecondComparator,
    editable: false,
    sortable: true,
    resizable: true,
    isTextColorRed: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    dataAlignRight: true,
    cellRenderer: 'adjustedUnitsCellRender',
    excelAlignment: 'right',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    sortingOrder: ['desc', 'asc'],
    exportZeroesThree: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Disputed Units',
    field: 'disputedUnits',
    editable: false,
    sortable: true,
    resizable: true,
    isTextColorRed: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    comparator: amountComparator,
    cellRenderer: 'TotalUnitsCellRender',

    cellEditor: MaxLengthNumericEditor,
    dataAlignRight: true,
    excelAlignment: 'right',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    exportZeroesThree: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Units Paid',
    field: 'paidUnits',
    editable: false,
    sortable: true,
    resizable: true,
    isTextColorRed: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    comparator: amountComparator,

    cellEditor: MaxLengthNumericEditor,
    dataAlignRight: true,
    excelAlignment: 'right',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    exportZeroesThree: true,
    cellRenderer: 'TotalUnitsCellRender',

    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Adj Code 1',
    field: 'adjcd1',
    editable: false,
    sortable: true,
    resizable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Adj Code 2',
    field: 'adjcd2',
    editable: false,
    sortable: true,
    resizable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Adj Code 3',
    field: 'adjcd3',
    editable: false,
    sortable: true,
    resizable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Dispute Code 1',
    field: 'dispcd1',
    editable: false,
    sortable: true,
    resizable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Dispute Code 2',
    field: 'dispcd2',
    editable: false,
    sortable: true,
    resizable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Dispute Code 3',
    field: 'dispcd3',
    editable: false,
    sortable: true,
    resizable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Rebate Amount Invoiced',
    field: 'rebateAmtInvoiced',
    comparator: amountComparator,
    editable: false,
    sortable: true,
    resizable: true,
    suppressMenu: false,
    isTextColorRed: true,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    dataAlignRight: true,
    // exportZeroesTwo: true,
    cellRenderer: CustomGridCellRendererComponent,
    printPrefixValue: '$',
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Invoice Correction Amount',
    field: 'invoiceCorrectionAmt',
    comparator: amountComparator,
    editable: false,
    sortable: true,
    resizable: true,
    isTextColorRed: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    dataAlignRight: true,
    // exportZeroesTwo: true,
    cellRenderer: CustomGridCellRendererComponent,
    printPrefixValue: '$',
    excelAlignment: 'right',

    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Withheld Invoice Amount',
    field: 'withheldInvoiceAmt',
    comparator: amountComparator,
    editable: false,
    sortable: true,
    resizable: true,
    isTextColorRed: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    dataAlignRight: true,
    // exportZeroesTwo: true,
    cellRenderer: CustomGridCellRendererComponent,
    printPrefixValue: '$',
    excelAlignment: 'right',

    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Paid Amount',
    field: 'paidAmt',
    comparator: amountComparator,
    editable: false,
    sortable: true,
    resizable: false,
    isTextColorRed: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    dataAlignRight: true,
    // exportZeroesTwo: true,
    cellRenderer: CustomGridCellRendererComponent,
    printPrefixValue: '$',
    excelAlignment: 'right',
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const TableHeaderForPQASDetails = [
  {
    headerName: 'NDC',
    field: 'ndc',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_200,
    cellRenderer: 'HyperLinkNameRender',
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Drug Name',
    field: 'drugName',
    editable: false,
    sortable: true,
    resizable: true,
    suppressMenu: false,
    columnSpan: 4,
    minWidth: Styles.Width_250,
    cellRenderer: 'FullNameRender',
    cellClass: 'frr-ellipsis-text',
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Current URA',
    field: 'currUnitRebateAmt',
    editable: false,
    sortable: true,
    resizable: true,
    suppressMenu: false,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    sortingOrder: ['desc', 'asc'],
    dataAlignRight: true,
    exportZeroesSix: true,
    excelAlignment: 'right',
    cellRenderer: 'UnitRebateAmtCellRender',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Current Units',
    field: 'currUnits',
    editable: false,
    sortable: true,
    resizable: true,
    suppressMenu: false,
    isTextColorRed: true,
    minWidth: Styles.Width_200,
    comparator: amountComparator,

    cellEditor: MaxLengthNumericEditor,
    dataAlignRight: true,
    excelAlignment: 'right',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    sortingOrder: ['desc', 'asc'],
    exportZeroesThree: true,
    cellRenderer: 'TotalUnitsCellRender',

    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Prior Units Paid',
    field: 'priorPaidUnits',
    editable: false,
    sortable: true,
    resizable: true,
    suppressMenu: false,
    isTextColorRed: true,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    comparator: amountComparator,

    excelAlignment: 'right',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    dataAlignRight: true,
    exportZeroesThree: true,
    cellRenderer: 'TotalUnitsCellRender',

    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Current Units Paid',
    field: 'currUnitsPaid',
    editable: false,
    sortable: true,
    resizable: true,
    suppressMenu: false,
    isTextColorRed: true,
    minWidth: Styles.Width_200,
    comparator: amountComparator,

    cellEditor: MaxLengthNumericEditor,
    excelAlignment: 'right',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    sortingOrder: ['desc', 'asc'],
    dataAlignRight: true,
    exportZeroesThree: true,
    cellRenderer: 'TotalUnitsCellRender',

    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Prior Units Disputed',
    field: 'priorDisputedUnits',
    editable: false,
    sortable: true,
    resizable: true,
    suppressMenu: false,
    isTextColorRed: true,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    comparator: amountComparator,

    excelAlignment: 'right',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    dataAlignRight: true,
    exportZeroesThree: true,
    cellRenderer: 'TotalUnitsCellRender',

    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Current Units Disputed',
    field: 'currUnitsDisputed',
    editable: false,
    sortable: true,
    resizable: true,
    suppressMenu: false,
    isTextColorRed: true,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    comparator: amountComparator,

    dataAlignRight: true,
    excelAlignment: 'right',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    exportZeroesThree: true,
    cellRenderer: 'TotalUnitsCellRender',

    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Original Amount Invoiced',
    field: 'orignalInvoiceAmt',
    comparator: amountComparator,
    editable: false,
    sortable: true,
    resizable: true,
    suppressMenu: false,
    isTextColorRed: true,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    dataAlignRight: true,
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    // exportZeroesTwo: true,
    cellRenderer: CustomGridCellRendererComponent,
    printPrefixValue: '$',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Revised Invoice Amount',
    field: 'revisedInvoiceAmt',
    comparator: amountComparator,
    editable: false,
    sortable: true,
    resizable: true,
    isTextColorRed: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,

    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    dataAlignRight: true,
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    // exportZeroesTwo: true,
    cellRenderer: CustomGridCellRendererComponent,
    printPrefixValue: '$',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Prior Amount Paid',
    field: 'priorPaidAmt',
    comparator: amountComparator,
    editable: false,
    sortable: true,
    resizable: true,
    isTextColorRed: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    dataAlignRight: true,
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    // exportZeroesTwo: true,
    cellRenderer: CustomGridCellRendererComponent,
    printPrefixValue: '$',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Current Amount Paid',
    field: 'currAmtPaid',
    comparator: amountComparator,
    editable: false,
    sortable: true,
    resizable: true,
    suppressMenu: false,
    isTextColorRed: true,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: CustomGridCellRendererComponent,
    printPrefixValue: '$',

    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    dataAlignRight: true,
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    // exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Amount Paid This Transaction',
    field: 'paidThisTransactionAmt',
    comparator: amountComparator,
    editable: false,
    sortable: true,
    resizable: true,
    isTextColorRed: true,
    suppressMenu: false,
    minWidth: Styles.Width_300,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    dataAlignRight: true,
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    // exportZeroesTwo: true,
    cellRenderer: CustomGridCellRendererComponent,
    printPrefixValue: '$',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Adj Code 1',
    field: 'adjcd1',
    editable: false,
    sortable: true,
    resizable: true,
    suppressMenu: false,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Adj Code 2',
    field: 'adjcd2',
    editable: false,
    sortable: true,
    resizable: true,
    suppressMenu: false,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Adj Code 3',
    field: 'adjcd3',
    editable: false,
    sortable: true,
    resizable: true,
    suppressMenu: false,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Dispute Code 1',
    field: 'dispcd1',
    editable: false,
    sortable: true,
    resizable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Dispute Code 2',
    field: 'dispcd2',
    editable: false,
    sortable: true,
    resizable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Dispute Code 3',
    field: 'dispcd3',
    editable: false,
    sortable: true,
    resizable: false,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
